import type { Component } from 'vue';
import type { AppLayoutCode } from '@integro/core';
import { AppLayoutTabbed } from './AppLayoutTabbed';
import { AppLayoutSidebar } from './AppLayoutSidebar';

export { AppLayoutTabbed, AppLayoutSidebar };

export function pickRootComponent(layout: AppLayoutCode): Component {
  switch (layout) {
    case 'sidebar':
      return AppLayoutSidebar;
    case 'tabbed':
    default:
      return AppLayoutTabbed;
  }
}
